
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/club/[club]/alumni",
      function () {
        return require("private-next-pages/club/[club]/alumni.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/club/[club]/alumni"])
      });
    }
  